import MonthlyReconciliationDetail from './MonthlyReconciliationDetail';

const OpenTab = () => <MonthlyReconciliationDetail embedInOpenTab />;

export default OpenTab;
